var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useDeploymentGuard } from '#hooks';
import { workspaceRoutes } from '#services';
/**
 * Guards the create-filespace route entry against an in-progress WebService
 * deploy. On entry it runs the deployment check once: if a deploy is in
 * progress the shared guard opens the modal and the user is sent back to where
 * they came from; otherwise the route renders. Fail-open is handled by the
 * shared guard (a status-check error lets the route through).
 */
export const FilespaceCreateRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { key: locationKey } = useLocation();
    const navigate = useNavigate();
    const { guard } = useDeploymentGuard();
    const guardRef = useRef(guard);
    guardRef.current = guard;
    const [isAllowed, setIsAllowed] = useState(false);
    useEffect(() => {
        let isCancelled = false;
        const runGuard = async () => {
            let isActionAllowed = false;
            try {
                await guardRef.current(() => {
                    isActionAllowed = true;
                }, { workspaceId });
            }
            catch {
                // fail-open: never leave the user stuck on the loader
                isActionAllowed = true;
            }
            if (isCancelled) {
                return;
            }
            if (isActionAllowed) {
                setIsAllowed(true);
                return;
            }
            // when link was pasted there is no history and
            // navigate(-1) is a no-op
            if (locationKey === 'default') {
                void navigate(workspaceRoutes.workspace(workspaceId));
            }
            else {
                void navigate(-1);
            }
        };
        void runGuard();
        return () => {
            isCancelled = true;
        };
    }, [locationKey, navigate, workspaceId]);
    if (!isAllowed) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking deployment status'), "data-testid": "checking-deployment-status", isFullHeight: true }) }));
    }
    return children;
};
_react_refresh_temp_1 = FilespaceCreateRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "FilespaceCreateRouteGuard");
_react_refresh_temp_2(FilespaceCreateRouteGuard, "w9/gOs+WlTBqzXg01gdwIF8/vs4=", false, () => [useParams, useLocation, useNavigate, useDeploymentGuard]);
